<app-main-header [name_main]="titleheader">
  @if ((boardForm.get('type')?.value === 'urlBi' && boardForm.get('urlBi')?.value) ||
  (boardForm.get('type')?.value === 'metabase' && boardForm.get('dashboard')?.valid)) {
  <button mat-stroked-button color="primary" type="button" [disabled]="previewLoading" (click)="togglePreview()">
    <mat-icon>{{ showPreview ? 'edit' : 'visibility' }}</mat-icon>
    {{ showPreview ? 'Volver al formulario' : (previewLoading ? 'Cargando…' : 'Previsualizar') }}
  </button>
  }
  @if(creating){
  <button mat-flat-button color="primary" [disabled]="!boardForm.valid" (click)="saveBoard()">
    Guardar
  </button>
  }@else {
  <!-- <button class="check-btn" mat-flat-button (click)="openBottomSheet()"></button> -->
  <button mat-flat-button color="primary" [disabled]="!boardForm.valid || !for_save" (click)="saveBoard()">
    Guardar
  </button>
  }
</app-main-header>

<div [formGroup]="boardForm">
  @if (!showPreview) {
  <div class="board-data">
    <div class="params-card">
      <div class="params-card__info">
        <mat-icon>settings</mat-icon>
        <div>
          <p class="params-card__title">Parámetros personalizados</p>
          <p class="params-card__subtitle">Úsalo para tableros que necesitan parámetros propios por usuario, como SDV.</p>
        </div>
      </div>
      <button color="primary" mat-stroked-button type="button" (click)="openParametersObjectsModal()">
        Configurar parámetros
      </button>
    </div>

    @if (parameters_summary_vm$ | async; as parameters_summary_vm) {
    @if (parameters_summary_vm.has_parameters) {
    <div class="parameters-summary">
      <mat-chip-set class="parameters-summary__chips">
        @for (param of parameters_summary_vm.parameter_object_entries; track param.key) {
        <mat-chip-row class="parameters-summary__chip">
          {{ param.label }}
        </mat-chip-row>
        }
      </mat-chip-set>
    </div>
    }
    }

    @for (d of formConfig; track d.label; let idx = $index, e = $even) {
    @if (!(d.controlName === 'urlBi' && boardForm.get('type')?.value === 'metabase')) {
    <div class="form" [ngStyle]="{ width: d.width, margin: d.margin }">
      <mat-form-field class="outline">
        <mat-label>{{ d.label }}</mat-label>

        <input *ngIf="d.type !== 'select'" matInput [formControlName]="d.controlName" [type]="d.type" />

        <mat-select *ngIf="d.type === 'select'" [formControlName]="d.controlName"
          (selectionChange)="onTypeSelectionChange(d.controlName, $event.value)">
          <mat-option *ngFor="let item of (d.controlName === 'client_id' ? clients : types)"
            [value]="d.controlName === 'client_id' ? item.client_id : item.value">
            {{ d.controlName === 'client_id' ? item.name : item.viewValue }}
          </mat-option>
        </mat-select>
        <!-- Select para tipo de tablero (NUEVO) -->
        <mat-hint *ngIf="d.controlName === 'urlBi' && boardForm.get('type')?.value === 'params'">
          Pon {{ paramsPlaceholder }} donde va el valor de cada usuario. Ej: https://…/?uuid={{ paramsPlaceholder }}
        </mat-hint>
        <mat-error *ngIf="d.controlName === 'urlBi' && boardForm.get('urlBi')?.errors?.['missingPlaceholder']">
          La URL debe incluir al menos un parámetro, ej. {{ paramsPlaceholder }}.
        </mat-error>
      </mat-form-field>
    </div>
    <div *ngIf="boardForm.get(d.controlName)?.errors?.['minlength'] && boardForm.get(d.controlName)?.touched">
      <mat-error>
        <small>El valor ingresado debe ser superior a 2 caracteres.</small>
      </mat-error>
    </div>
    }

    @if (d.controlName === 'type' && boardForm.get('type')?.value === 'metabase') {
    <div class="form" style="width: 100%">
      <mat-form-field class="outline">
        <mat-label>ID de Dashboard en Metabase</mat-label>
        <input matInput type="number" formControlName="dashboard" />
        <mat-error *ngIf="boardForm.get('dashboard')?.errors?.['required'] && boardForm.get('dashboard')?.touched">
          <small>Este campo es requerido para tableros tipo Metabase.</small>
        </mat-error>
      </mat-form-field>
    </div>
    }
    } <!-- Cierra el bucle @for -->

    <!-- <div class="upload-image">
      <button class="upload-btn" mat-stroked-button type="button" (click)="fileInput.click()">
        <mat-icon>attach_file</mat-icon>
      </button>
      <input #fileInput type="file" (change)="onFileSelected($event)" hidden accept=".png,.jpg,.jpeg"
        matTooltip="Subir imagen del tablero" />
      <img *ngIf="selectedFile" [src]="selectedFile" class="image-preview" />
    </div> -->
  </div>

  <mat-accordion class="accordion-container">
    <mat-expansion-panel [expanded]="rolesPanelExpanded" (opened)="rolesPanelExpanded = true"
      (closed)="rolesPanelExpanded = false" class="roles-panel">
      <mat-expansion-panel-header>
        <mat-panel-title class="roles-panel__title"> Usuarios con acceso</mat-panel-title>
        <mat-panel-description class="roles-panel__emails" *ngIf="roleEmailsSummary$ | async as roleEmailsSummary">
          {{ roleEmailsSummary }}
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="roles-panel__search-row">
        <mat-form-field class="outline roles-panel__search" subscriptSizing="dynamic">
          <mat-label>Agregar usuario por correo</mat-label>
          <div class="search-container">
            <input matInput placeholder="Buscar correos" [matAutocomplete]="auto" [formControl]="roleSearchCtrl"
              (keydown.enter)="addRoleFromInput()" />
            <mat-icon>search</mat-icon>
          </div>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUserEmail"
            (optionSelected)="addRole($event.option.value)">
            <mat-option *ngFor="let user of filteredUsers | async" [value]="user">
              {{ user.email }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <button class="roles-panel__action-btn roles-panel__action-btn--download" mat-icon-button type="button"
          (click)="downloadCsv()" matTooltip="Descargar">
          <mat-icon>download</mat-icon>
        </button>
        <button class="roles-panel__action-btn roles-panel__action-btn--upload" mat-icon-button type="button"
          [disabled]="!boardUid" (click)="openImportModal()" matTooltip="Cargar">
          <mat-icon>upload</mat-icon>
        </button>
      </div>

      <app-data-table [data]="(roleRows$ | async) ?? []" [columns]="columns" [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]" [sortField]="'name'" [sortOrder]="-1" [showFilters]="true"
        [deleteButton]="true" [showSelection]="false" [dense]="true" [scrollable]="true" [scrollHeight]="'220px'"
        [globalFilterFields]="['name', 'email']"
        (deleteItems)="onDeleteItems($event)" (editItem)="onEditItem($event)">
      </app-data-table>
    </mat-expansion-panel>

    <!-- Seccion de consultas -->
    <div class="params-card">
      <div class="params-card__info">
        <mat-icon>download</mat-icon>
        <div>
          <p class="params-card__title">Descargables</p>
          <p class="params-card__subtitle">Agrega consultas descargables para este tablero, con nombre, host, tipo y rango de fechas.</p>
        </div>
      </div>
      <button #tooltip="matTooltip" matTooltip="Agregar Nuevo" color="primary" mat-stroked-button type="button"
        (click)="addQuery()">
        Agregar descargable
      </button>
    </div>
    @if (queriesArray.length > 0) {
    <div class="queries-panel-shell" formArrayName="queries">
      <mat-expansion-panel [expanded]="true" class="queries-container">
        <mat-expansion-panel-header>
        </mat-expansion-panel-header>

        <div *ngFor="let query of queriesArray.controls; let i = index" [formGroupName]="i" class="query-group"
          fxLayout="row" fxLayoutAlign="center" fxLayoutGap="4px">

          <div class="label-active-btns">
            <mat-label>{{ query.get('active')?.value ? 'Activo' : 'Inactivo' }}</mat-label>
            <mat-checkbox formControlName="active" color="primary"></mat-checkbox>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="name" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Host</mat-label>
            <input matInput formControlName="host" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Tipo</mat-label>
            <input matInput formControlName="type" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Fechas</mat-label>
            <mat-date-range-input [rangePicker]="picker" formGroupName="params">
              <input matStartDate formControlName="start_date" placeholder="Fecha de inicio" />
              <input matEndDate formControlName="end_date" placeholder="Fecha de fin" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>

          <button style="align-self: center" mat-icon-button color="warn" (click)="removeQuery(i)">
            <span class="material-symbols-outlined">delete</span>
          </button>
        </div>
      </mat-expansion-panel>
    </div>
    }
  </mat-accordion>
  }
  @else {
  <div class="preview-frame">
    @if (previewError) {
    <div class="preview-frame__error">{{ previewError }}</div>
    } @else {
    <iframe
      [src]="(boardForm.get('type')?.value === 'metabase' ? metabasePreviewUrl : boardForm.get('urlBi')?.value) | safe"
      frameborder="0" allowFullScreen="true"></iframe>
    }
  </div>
  }